import { useCallback } from 'react'
import { ListItemIcon, ListItemText, MenuItem, Stack } from '@mui/material'
import { Check } from '@mui/icons-material'

import { SortAscending, SortDescending } from '@/icons'
import { ListHeaderSorter } from '@/components/List'

import { useTexts } from '../../../../useTexts'
import { useSorter } from './hooks/useSorter'

export function Sorter() {
  const { direction, editing, setDirection, noEntries } = useSorter()
  const texts = useTexts()

  const onSortAscending = useCallback(() => {
    setDirection('asc')
  }, [setDirection])

  const onSortDescending = useCallback(() => {
    setDirection('desc')
  }, [setDirection])

  const triggerText = direction === 'asc' ? texts.sortByAscending : texts.sortByDescending

  if (noEntries) return null

  return (
    <ListHeaderSorter triggerText={triggerText} disabled={editing}>
      <MenuItem
        onClick={onSortAscending}
        data-testid="list-header-sorter-sortDirection-ascending"
        data-trackid="list-header-sorter-sortDirection-ascending"
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          align-items="center"
          width="100%"
          gap={2}
        >
          <Stack direction="row">
            {direction === 'asc' && (
              <ListItemIcon>
                <Check color="primary" />
              </ListItemIcon>
            )}

            <ListItemText inset={direction !== 'asc'} primary={texts.sortOrderAscending} />
          </Stack>

          <Stack justifyContent="center" color="action.active">
            <SortAscending size={20} />
          </Stack>
        </Stack>
      </MenuItem>

      <MenuItem
        onClick={onSortDescending}
        data-testid="list-header-sorter-sortDirection-descending"
        data-trackid="list-header-sorter-sortDirection-descending"
      >
        <Stack
          justifyContent="space-between"
          align-items="center"
          direction="row"
          width="100%"
          gap={2}
        >
          <Stack direction="row" color="light">
            {direction === 'desc' && (
              <ListItemIcon>
                <Check color="primary" />
              </ListItemIcon>
            )}

            <ListItemText inset={direction !== 'desc'} primary={texts.sortOrderDescending} />
          </Stack>

          <Stack justifyContent="center" color="action.active">
            <SortDescending size={20} />
          </Stack>
        </Stack>
      </MenuItem>
    </ListHeaderSorter>
  )
}
